

import { useEffect, useRef, useState } from "react"
import "../css/WelcomeSection.css" // Updated responsive styling
import { Col, Container, Row } from "react-bootstrap"
import { motion, useInView } from "framer-motion"

import fff from "../images/Vaccines .png"
import sd from "../images/Hyperimmune serums.png"
import dsds from "../images/Endo.png"
import cdcd from "../images/Medicines.png"
import cvcv from "../images/Disgnostic.png"
import dfdf from "../images/Supplements.png"
import c1 from "../images/IMG (34).webp"

import cc from "../images/PBT REMAIMING IMG (2).webp"
import vvvvv from "../images/Video of welcome to pbt webm.webm"
import { Helmet } from "react-helmet-async"

function WelcomeSection() {
  const sectionRef = useRef(null)
  const productRef = useRef(null)
  const isInView = useInView(sectionRef, { threshold: 0.1, once: false })
  const isProductInView = useInView(productRef, { threshold: 0.2, once: false })

  // State for screen size detection
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const handleNavigate = (productName) => {
    window.location.href = `/products?category=${productName}`; // Navigate to the products page
  }
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 992)
    }

    handleResize() // Initial check
    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const products = [
    { name: "Vaccines", icon: fff },
    { name: "Hyperimmune serums", icon: sd },
    { name: "Endocrinology", icon: dsds },
    { name: "Therapeutic Solutions", icon: cdcd },
    { name: "Diagnostic Kits", icon: cvcv },
    { name: "Nutraceuticals", icon: dfdf },
  ]

  // Animation variants with responsive adjustments - ALL FROM DOWN TO UP
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: isMobile ? 0.2 : 0.15,
        delayChildren: 0.1,
      },
    },
  }

  const cardVariants = {
    hidden: {
      opacity: 0,
      y: isMobile ? 50 : 60, // Start from below
      scale: isMobile ? 1 : 0.9,
    },
    visible: {
      opacity: 1,
      y: 0, // Move up to original position
      scale: 1,
      transition: {
        duration: isMobile ? 0.6 : 0.5,
        ease: "easeOut",
        type: "spring",
        stiffness: isMobile ? 100 : 120,
        damping: isMobile ? 20 : 15,
      },
    },
  }

  const productTitleVariants = {
    hidden: {
      opacity: 0,
      y: 30, // Start from below
    },
    visible: {
      opacity: 1,
      y: 0, // Move up to original position
      transition: {
        duration: 0.4,
        ease: "easeOut",
        delay: 0.1,
      },
    },
  }

  const textVariants = {
    hidden: {
      y: isMobile ? 50 : 80, // Start from below
      opacity: 0,
    },
    visible: {
      y: 0, // Move up to original position
      opacity: 1,
      transition: {
        duration: isMobile ? 0.6 : 1,
        delay: isMobile ? 0.2 : 0.3,
      },
    },
  }

  const videoVariants = {
    hidden: {
      y: isMobile ? 60 : 100, // Start from below
      opacity: 0,
    },
    visible: {
      y: 0, // Move up to original position
      opacity: 1,
      transition: {
        duration: isMobile ? 0.6 : 1,
        delay: isMobile ? 0.3 : 0.5,
      },
    },
  }

  const sideImageVariants = {
    left: {
      hidden: { y: 80, opacity: 0 }, // Start from below instead of left
      visible: {
        y: 0, // Move up to original position
        opacity: 1,
        transition: { duration: isMobile ? 0.6 : 1 },
      },
    },
    right: {
      hidden: { y: 80, opacity: 0 }, // Start from below instead of right
      visible: {
        y: 0, // Move up to original position
        opacity: 1,
        transition: { duration: isMobile ? 0.6 : 1 },
      },
    },
  }

  return (
    <>
      {/* Helmet for SEO */}
      <Helmet>
        <title>WELCOME TO PANAV BIO-TECH</title>
        <meta name="description" content=' Panav Biotech: Advancing Animal Health, Elevating Lives
                        At Panav Biotech, our guiding philosophy is rooted in evidence-based veterinary science. We are committed to fostering awareness of the critical role animal health products play in ensuring longevity, vitality, and well-being across species. By delivering innovative, research-driven, and high-quality veterinary solutions at accessible prices, we strive to enhance the overall health outcomes and quality of life within the animal kingdom.' />
        <meta property="og:title" content='WELCOME TO PANAV BIO-TECH' />
        <meta property="og:description" content=' Panav Biotech: Advancing Animal Health, Elevating Lives
                        At Panav Biotech, our guiding philosophy is rooted in evidence-based veterinary science. We are committed to fostering awareness of the critical role animal health products play in ensuring longevity, vitality, and well-being across species. By delivering innovative, research-driven, and high-quality veterinary solutions at accessible prices, we strive to enhance the overall health outcomes and quality of life within the animal kingdom.' />
        <meta property="og:image" content={c1} />
      </Helmet>
      <section ref={sectionRef} className="welcome-dog-section position-relative">
        {/* Left Image Animation - Hidden on mobile via CSS */}
        <motion.img
          src={cc}
          alt="Welcome decoration"
          className="left-side-half-circle"
          variants={sideImageVariants.left}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        />

        <Container fluid={isMobile} className={isMobile ? "px-3" : ""}>
          <Row className="d-flex align-items-center justify-content-center mb-5 position-relative welcome-section">
            <Col lg={12} md={12} className="d-flex align-items-center home-welcome-row content-section">
              <Row className="w-100 g-0">
                {/* Text Section */}
                <Col md={6} xs={12} className="welcome-home-heading text-left order-1 order-md-1">
                  <motion.div variants={textVariants} initial="hidden" animate={isInView ? "visible" : "hidden"}>
                    <h2 className="fw-boldd text-center text-white mb-2 ">WELCOME TO</h2>
                    <h2 className="fw-boldd text-center text-white font-bold">PANAV BIO-TECH</h2>
                  </motion.div>
                </Col>

                {/* Video and Text Content */}
                <Col md={6} xs={12} className="p-0 position-relative text-content-container order-2 order-md-2">
                  <motion.div
                    variants={videoVariants}
                    initial="hidden"
                    animate={isInView ? "visible" : "hidden"}
                    className="position-relative"
                  >
                    <video
                      src={vvvvv}
                      className="video-background"
                      autoPlay
                      loop
                      muted
                      playsInline
                      preload="metadata"
                    />

                    <div className="text-content-overlay text-white">
                      <p className={`${isMobile ? "text-left" : "text-justify"} m-0`}>
                        <strong>Panav Biotech</strong>: Advancing Animal Health, Elevating Lives
                        At Panav Biotech, our philosophy is rooted in <strong>evidence-based veterinary science</strong>  and a deep commitment to improving animal well-being. We strive to raise awareness about the vital role of animal health products in promoting <strong>longevity, vitality, and quality of life</strong>  across species.
                        <br />
                        Through <b>innovative, research-driven, and high-quality veterinary solutions,</b> we aim to make advanced animal care synonymous with scientific excellence and trust. Our focus on <b>innovation and precision</b> ensures that every product reflects our unwavering dedication to excellence in animal health.
                        <br />
                        Our core values of <b>integrity, scientific excellence, loyalty, trust, and appreciation</b> form the foundation of our relationship with veterinarians, pet parents, and the livestock sector.
                        These principles position <b>Panav Biotech</b> as a <b>trusted leader in veterinary healthcare</b>, bridging the gap between <b>cutting-edge science</b> and <b>practical clinical application</b>.
                      </p>
                    </div>
                  </motion.div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>

        {/* Right Image Animation - Hidden on mobile via CSS */}
        <motion.img
          src={c1}
          alt="Welcome decoration"
          className="right-side-half-circle"
          variants={sideImageVariants.right}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        />
      </section>

      {/* Product Grid Section */}
      <Container ref={productRef} className="welcome-section-container my-5" fluid={isMobile}>
        <motion.div
          className="text-center my-5"
          variants={containerVariants}
          initial="hidden"
          animate={isProductInView ? "visible" : "hidden"}
        >
          <motion.h2
            className="mb-4 home-our-product"
            initial={{ opacity: 0, y: 50 }} // Start from below
            animate={isProductInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} // Move up to original position
            transition={{
              duration: 0.8,
              ease: "easeOut",
              delay: 0.2,
            }}
          >
            OUR PRODUCTS
          </motion.h2>

          <Row className={`${isMobile ? "g-3" : "g-4"} justify-content-center`}>
            {products.map((product, index) => (
              <Col key={index} xs={6} sm={6} md={4} lg={2} className="mb-4 d-flex flex-column align-items-center">
                <motion.div className="d-flex flex-column align-items-center" variants={cardVariants} custom={index}>
                  <motion.div
                    className="product-circle shadow-sm" onClick={() => { handleNavigate(product?.name) }}
                    whileHover={
                      !isMobile
                        ? {
                          scale: 1.08,
                          y: -5,
                          transition: { duration: 0.3, ease: "easeOut" },
                        }
                        : {}
                    }
                    whileTap={{
                      scale: 0.95,
                      transition: { duration: 0.1 },
                    }}
                  >
                    <img src={product.icon} className="product-icon-home" alt={product.name} loading="lazy" />
                  </motion.div>

                  <motion.p className="mt-2 home-product-name text-center" variants={productTitleVariants}>
                    {product.name}
                  </motion.p>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </>
  )
}

export default WelcomeSection
